import { EnquiryProductCategoryEnum } from "@gtpl/shared-models/masters"
import { OrderTypeEnum, StyleWeighmentEnum } from "../enum"

export class EnQuiryManagementProductReq{
    productId:number
    enquiryId:number
    category:EnquiryProductCategoryEnum
    brandId:number
    variantId:number
    packstyleId:number
    styleWeighment:StyleWeighmentEnum
    unitPrice:number
    noOfCases:number
    caseWeight:number
    netWeight:number
    netAmount:number
    noOfSkewers:number//for skewer category
    varietyId:number//size for rings and skewers
    packCount: number
    shrimpWeight: number
    orderType:OrderTypeEnum
    uomId:number
    packMaterialCost:number
    grouping:number
    noOfContainers:number
    uvPriceCategory:string
    uvType:string
    uvPercentOrCent:number
    brandType:string
    priceBasedOn : string
    constructor(
    productId:number,
    enquiryId:number,
    category:EnquiryProductCategoryEnum,
    brandId:number,
    variantId:number,
    packstyleId:number,
    styleWeighment:StyleWeighmentEnum,
    unitPrice:number,
    noOfCases:number,
    caseWeight:number,
    netWeight:number,
    netAmount:number,
    noOfSkewers:number,//for skewer category
    varietyId:number,//size for rings and skewers
    packCount: number,
    shrimpWeight: number,
    orderType:OrderTypeEnum,
    uomId:number,
    packMaterialCost: number,
    grouping:number,
    noOfContainers:number,
    uvPriceCategory:string,
    uvType:string,
    uvPercentOrCent:number,
    brandType:string,
    priceBasedOn : string
    ){
        this.productId=productId
        this.enquiryId=enquiryId
        this.category=category
        this.brandId=brandId
        this.variantId=variantId
        this.packstyleId=packstyleId
        this.styleWeighment=styleWeighment
        this.unitPrice=unitPrice
        this.noOfCases=noOfCases
        this.caseWeight=caseWeight
        this.netWeight=netWeight
        this.netAmount=netAmount
        this.noOfSkewers=noOfSkewers
        this.varietyId=varietyId
        this.packCount = packCount
        this.shrimpWeight = shrimpWeight
        this.orderType = orderType
        this.uomId=uomId
        this.packMaterialCost = packMaterialCost
        this.grouping = grouping
        this.noOfContainers = noOfContainers
        this.uvPriceCategory = uvPriceCategory
        this.uvType = uvType
        this.uvPercentOrCent = uvPercentOrCent
        this.brandType = brandType
        this.priceBasedOn = priceBasedOn

        }
}